import { useRuntimeConfig } from '#app';
let isHandlingUnauthorized = false;

const getBasePath = () => {
    const config = useRuntimeConfig();
    return config.public.api_url;
};

const getAuthToken = () => {
    const isPreviewing = sessionStorage.getItem('isPreview');
    return isPreviewing ? sessionStorage.getItem('token') : localStorage.getItem('token');
};

const handleUnauthorized = () => {
    if (isHandlingUnauthorized) return;
    isHandlingUnauthorized = true;
    localStorage.clear();
    sessionStorage.clear();

    if (typeof window !== 'undefined') {
        window.location.href = '/login';
    }

    isHandlingUnauthorized = false;
};

export const useAxiosGet = async (path) => {

    try {
        const token = getAuthToken()
        const res = await $fetch(`${getBasePath()}/${path}`, {
            method: 'GET',
            headers: {
                authorization: `Bearer ${token}`
            }
        })
        return res
    } catch (error) {
        if (error.statusCode === 401) {
            handleUnauthorized()
        }
        console.log('Error DATA GET :', error.data)
        throw error.data
    }

}

export const useAxiosPost = async (path, request_body) => {
    try {
        const token = getAuthToken()
        const res = await $fetch(`${getBasePath()}/${path}`, {
            method: 'POST',
            body: JSON.stringify(request_body),
            headers: {
                authorization: `Bearer ${token}`
            }
        })
        return res
    } catch (error) {
        if (error.statusCode === 401) {
            handleUnauthorized()
        }
        console.log('Error DATA POST :', error.data)
        throw error.data
    }
}

export const useAxiosPatch = async (path, request_body) => {
    try {
        const token = getAuthToken()
        const res = await $fetch(`${getBasePath()}/${path}`, {
            method: 'PATCH',
            body: JSON.stringify(request_body),
            headers: {
                authorization: `Bearer ${token}`
            }
        })
        return res
    } catch (error) {
        if (error.statusCode === 401) {
            handleUnauthorized()
        }
        console.log('Error DATA PATCH :', error.data)
        throw error.data
    }
}

export const useAxiosDelete = async (path) => {
    try {
        const token = getAuthToken()
        const res = await $fetch(`${getBasePath()}/${path}`, {
            method: 'DELETE',
            body: JSON.stringify({}),
            headers: {
                authorization: `Bearer ${token}`
            }
        })
        return res
    } catch (error) {
        if (error.statusCode === 401) {
            handleUnauthorized()
        }
        console.log('Error DATA DELETE:', error.data)
        throw error.data
    }
}

export const useAxiosFormDataPost = async (path, formData) => {

    try {
        const token = getAuthToken()
        const res = await $fetch(`${getBasePath()}/${path}`, {
            method: 'POST',
            body: formData,
            headers: {
                authorization: `Bearer ${token}`
            }
        })
        return res
    } catch (error) {
        if (error.statusCode === 401) {
            handleUnauthorized()
        }
        console.log('Error DATA FORMDATA:', error.data)
        throw error.data
    }


}

// Only for screenshot monitor

export const useAxiosForSSM = async (api_key, path, request_body) => {

    try {
        const { data } = await $fetch(`https://screenshotmonitor.com/api/v2/${path}`, {
            method: 'POST',
            body: JSON.stringify(request_body),
            headers: {
                "X-SSM-Token": api_key,
                "Content-type": "application/json",
            },
        })
        return data
    } catch (error) {
        console.log('Error DATA:', error.data)
        throw error.data
    }


}
